import { takeEvery, call, put, select } from "redux-saga/effects";
import actionTypes from "_constants/actionTypes";
import { xcService } from "_services/xcService";
import { history } from "_helpers/history";

import variables from "_constants/variables";

import localOrSessionStore from "_helpers/localOrSessionStore";
export default function* watcherAuthenticationTutor() {
  yield takeEvery(actionTypes.LOGIN_TUTOR, loginUser);
  yield takeEvery(actionTypes.LOGOUT, logoutUser);
  yield takeEvery(actionTypes.TUTOR_FORGOTPASSWORD, forgotPassword);
  //yield takeEvery(actionTypes.RESETPASSWORD, resetPassword);
  yield takeEvery(actionTypes.REGISTER_TUTOR, registerUser);
  yield takeEvery(actionTypes.ACTIVATE_COUNSELOR_BY_TOKEN, activateCounselor);
  yield takeEvery(actionTypes.GET_TUTORS, getTutors);
  yield takeEvery(actionTypes.INFO_CENTER, getInfoCenter);
  yield takeEvery(actionTypes.ACTIVATE_TUTOR_BY_ID, activateTutorById);
  yield takeEvery(actionTypes.ACTIVATE_COUNSELOR_BY_TOKEN_DONE, getTutors);
  yield takeEvery(actionTypes.REGISTER_CENTER, registerCenter);
  yield takeEvery(actionTypes.PDF_CENTER, contractCenter);
}


function* contractCenter({ payload }) {

  yield put({ type: actionTypes.START_REQUEST });

  try {
    let apiEndpoint = "/v1/tutor/auth/contractcenter";
    const res = yield call(
        () =>
            new Promise((resolve, reject) => {
              xcService.postToken(apiEndpoint, payload).then((response) => {
                resolve(response);
              });
            })
    );
    if (res.status === 200) {
      yield put({ type: actionTypes.PDF_CENTER_DATA, payload: res.data });
    } else {
      yield put({ type: actionTypes.PDF_CENTER_ERROR, payload: res.data });
    }
    yield put({ type: actionTypes.PDF_CENTER_CLEAR, payload: res.data });
  } catch (e) {
    yield put({ type: actionTypes.PDF_CENTER_ERROR, payload: e });
    yield put({ type: actionTypes.PDF_CENTER_CLEAR, payload: "ok" });
  }
  yield put({ type: actionTypes.END_REQUEST });
}


function* registerCenter({ payload }) {

  yield put({ type: actionTypes.START_REQUEST });

  try {
    let apiEndpoint = "/v1/tutor/auth/registercenter";
    const res = yield call(
        () =>
            new Promise((resolve, reject) => {
              xcService.post(apiEndpoint, payload).then((response) => {
                resolve(response);
              });
            })
    );
    if (res.status === 200) {
      yield put({ type: actionTypes.REGISTER_CENTER_DATA, payload: res.data });
    } else {
      yield put({ type: actionTypes.REGISTER_CENTER_ERROR, payload: res.data });
    }
    yield put({ type: actionTypes.CLEAN_REGISTER_DATA, payload: res.data });
  } catch (e) {
    yield put({ type: actionTypes.REGISTER_CENTER_ERROR, payload: e });
    yield put({ type: actionTypes.CLEAN_REGISTER_DATA, payload: "ok" });
  }
  yield put({ type: actionTypes.END_REQUEST });
}


function* registerUser({ payload }) {

  yield put({ type: actionTypes.START_REQUEST });

  try {
    let apiEndpoint = "/v1/tutor/auth/register";
    const res = yield call(
      () =>
        new Promise((resolve, reject) => {
          xcService.post(apiEndpoint, payload).then((response) => {
            resolve(response);
          });
        })
    );
    if (res.status === 200) {
      yield put({ type: actionTypes.REGISTER_USER_DATA, payload: res.data });
    } else {
      yield put({ type: actionTypes.REGISTER_USER_ERROR, payload: res.data });
    }
    yield put({ type: actionTypes.CLEAN_REGISTER_USER, payload: res.data });
  } catch (e) {
    yield put({ type: actionTypes.REGISTER_USER_ERROR, payload: e });
    yield put({ type: actionTypes.CLEAN_REGISTER_USER, payload: "ok" });
  }
  yield put({ type: actionTypes.END_REQUEST });
}

function* forgotPassword({ payload }) {
  yield put({ type: actionTypes.START_REQUEST });

  try {
    let apiEndpoint = "/v1/tutor/auth/reset";

    const res = yield call(
      () =>
        new Promise((resolve, reject) => {
          xcService.post(apiEndpoint, payload).then((response) => {
            resolve(response);
          });
        })
    );
    if (res.status === 200) {
      yield put({ type: actionTypes.TUTOR_FORGOTPASSWORD_DATA, payload: res.data });
    } else {
      yield put({ type: actionTypes.TUTOR_FORGOTPASSWORD_ERROR, payload: res.data });
    }
  } catch (e) {
    yield put({ type: actionTypes.FORGOTPASSWORD_ERROR, payload: e });
  }
  yield put({ type: actionTypes.END_REQUEST });
}


function* loginUser({ payload }) {
  if (payload.remember) {
    localStorage.setItem(variables.REMEMBER, "t");
  } else {
    localStorage.setItem(variables.REMEMBER, "f");
  }

  const storage = localOrSessionStore({ key: variables.REMEMBER });

  yield put({ type: actionTypes.START_REQUEST });

  try {
    let apiEndpoint = "/v1/tutor/auth/login";

    const res = yield call(
      () =>
        new Promise((resolve, reject) => {
          xcService.post(apiEndpoint, payload).then((response) => {
            resolve(response);
          });
        })
    );
    if (res.status === 200 && res.data.data.user.changepass) {
      storage.setItem(variables.USER, JSON.stringify(res.data.data.user));
      history.push("/tutorAuth/resetPassword");
    } else {
      if (res.status === 200 && res.data.data.token) {
        storage.setItem(variables.AUTH, "true");
        storage.setItem(variables.COMPLET, "0");
        storage.setItem(variables.TOKEN, res.data.data.token);
        storage.setItem(variables.TOKENREFRESH, res.data.data.refreshToken);
        storage.setItem(variables.USER, JSON.stringify(res.data.data.user));

        yield put({ type: actionTypes.LOGIN_DATA, payload: res.data.data });
        history.push("/tutorAuth/home");
      } else {

        yield put({ type: actionTypes.LOGIN_ERROR, payload: res.data });
      }
    }
  } catch (e) {
    yield put({ type: actionTypes.LOGIN_ERROR, payload: e });
  }
  yield put({ type: actionTypes.END_REQUEST });
}

function* activateCounselor({ payload }) {

  yield put({ type: actionTypes.START_REQUEST });

  try {
    let apiEndpoint = "/v1/tutor/auth/activate";

    const res = yield call(
      () =>
        new Promise((resolve, reject) => {
          xcService.post(apiEndpoint, payload).then((response) => {
            resolve(response);
          });
        })
    );
    if (res.status === 200 ) {
      history.push("/auth/login");
    } else {
      if (res.status === 200) {
        yield put({ type: actionTypes.TUTOR_VALIDATED, payload: "" });
        history.push("/auth/login");
      } else {

        yield put({ type: actionTypes.TUTOR_VALIDATED_ERROR, payload: "" });
      }
    }
  } catch (e) {
    yield put({ type: actionTypes.LOGIN_ERROR, payload: e });
  }
  yield put({ type: actionTypes.END_REQUEST });
}


function* getInfoCenter({ payload }) {

  yield put({ type: actionTypes.START_REQUEST });

  try {
    let apiEndpoint = "/v1/search/center/" + payload.code;

    const res = yield call(
        () =>
            new Promise((resolve, reject) => {
              xcService.get(apiEndpoint, null).then((response) => {
                resolve(response)
              })
            }),
    );

    if (res.status === 200 ) {
      yield put({ type: actionTypes.INFO_CENTER_DATA, payload: res.data.data });
    } else {

      yield put({ type: actionTypes.INFO_CENTER_ERROR, payload: "" });
    }

  } catch (e) {
    yield put({ type: actionTypes.INFO_CENTER_ERROR, payload: e });
  }
  yield put({ type: actionTypes.INFO_CENTER_CLEAR, payload: "" });
  yield put({ type: actionTypes.END_REQUEST });
}
function* getTutors({ payload }) {

  yield put({ type: actionTypes.START_REQUEST });

  try {
    let apiEndpoint = "/v1/tutor/tutors";

    const res = yield call(
      () =>
        new Promise((resolve, reject) => {
          xcService.getToken(apiEndpoint, payload).then((response) => {
            resolve(response);
          });
        })
    );
    if (res.status === 200 ) {
      yield put({ type: actionTypes.TUTORS_RETRIEVED, payload: res.data.data });
    } else {

      yield put({ type: actionTypes.TUTORS_RETRIEVED_ERROR, payload: "" });
    }
  } catch (e) {
    yield put({ type: actionTypes.LOGIN_ERROR, payload: e });
  }
  yield put({ type: actionTypes.END_REQUEST });
}

function* activateTutorById({ payload }) {

  yield put({ type: actionTypes.START_REQUEST });

  try {
    let apiEndpoint = "/v1/tutor/tutor/validate/";

    const res = yield call(
      () =>
        new Promise((resolve, reject) => {
          xcService.putToken(apiEndpoint+payload.id).then((response) => {
            resolve(response);
          });
        })
    );
    if (res.status === 200 ) {
      yield put({ type: actionTypes.ACTIVATE_COUNSELOR_BY_TOKEN_DONE, payload: "" });
    } else {

      yield put({ type: actionTypes.ACTIVATE_COUNSELOR_BY_TOKEN_ERROR, payload: "" });
    }
  } catch (e) {
    yield put({ type: actionTypes.ACTIVATE_COUNSELOR_BY_TOKEN_ERROR, payload: "" });
  }
}


function* logoutUser() {
  const storage = localOrSessionStore({ key: variables.REMEMBER });

  yield put({ type: actionTypes.START_REQUEST });
  storage.setItem(variables.AUTH, "false");
  storage.setItem(variables.COMPLET, "0");
  storage.removeItem(variables.TOKEN);
  storage.removeItem(variables.TOKENREFRESH);
  storage.removeItem(variables.USER);
  yield put({ type: actionTypes.LOGIN_DATA, payload: null});
  yield put({ type: actionTypes.END_REQUEST });
  history.push("/auth/login");
}
